var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.367,
    height: 10.786,
    viewBox: "0 0 9.367 10.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(13945.476 -5557.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M6.875,0V4.147H4.306V1.788L0,5.408,4.306,9.046V6.639H6.875v4.147H9.367V0Z",
    transform: "translate(-13936.109 5568.286) rotate(180)",
    fill: "#7e7e7e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnMoveIcon);
export default __webpack_public_path__ + "static/media/column-move-icon.eee74ccd3770ff078590d5d40b2b2a35.svg";
export { ForwardRef as ReactComponent };